(() => {
  let activeDialog = null;
  let previousOverflow = '';
  function setupGallery(dialog) {
    const gallery = dialog.querySelector('[data-quickview-gallery]');
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('.ls-quickview-track');
    const thumbs = [...gallery.querySelectorAll('[data-quickview-index]')];
    let frame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
        const selected = thumbs[index];
        if (selected) {
          const rail = selected.parentElement;
          const left = selected.offsetLeft - rail.offsetLeft;
          if (left < rail.scrollLeft || left + selected.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({left:Math.max(0,left - rail.clientWidth / 2 + selected.offsetWidth / 2),behavior:'auto'});
        }
      });
    }, {passive:true});
  }
  function moveGallery(gallery, step) {
    const track = gallery.querySelector('.ls-quickview-track');
    if (!track || !track.clientWidth) return;
    const count = track.children.length;
    if (count < 2) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    const next = (index + step + count) % count;
    track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }

  function showAddConfirmation(dialog) {
    const button = dialog && dialog.querySelector('button[type="submit"]');
    const label = button && button.querySelector('span');
    if (!button || !label) return;

    window.clearTimeout(button._lussoAddedTimer);
    if (!button.dataset.defaultLabel) button.dataset.defaultLabel = label.textContent.trim();
    label.textContent = 'Added to cart';
    button.classList.add('is-added');
    button.setAttribute('aria-live', 'polite');
    button._lussoAddedTimer = window.setTimeout(() => {
      label.textContent = button.dataset.defaultLabel || 'Add to cart';
      button.classList.remove('is-added');
    }, 1800);
  }
  document.addEventListener('keydown', event => {
    const gallery = event.target.closest('[data-quickview-gallery]');
    if (!gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    moveGallery(gallery, event.key === 'ArrowRight' ? 1 : -1);
  });
  // Optimaio attaches a document-level click handler to cart buttons. If its
  // optional cart refresh request fails (which is especially visible on iOS),
  // it can prevent the theme's native form submit even though the button
  // animation has already run. Let this quick-view form use Shopify's native
  // /cart/add.js flow; GoKwik still owns checkout after the cart is updated.
  document.addEventListener('click', event => {
    const nativeButton = event.target.closest('.ls-card-quickview [data-lusso-native-cart] button[type="submit"]');
    if (nativeButton && !nativeButton.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      nativeButton.form?.requestSubmit(nativeButton);
    }
  }, true);
  // Optimaio also listens to the form submit event. Handle this one form in
  // the capture phase so the native Shopify add request cannot be replaced by
  // a third-party cart refresh that may fail on iOS. The response is still
  // rendered through the theme cart drawer, so the UI and cart state stay in
  // sync.
  document.addEventListener('submit', event => {
    const form = event.target.closest('.ls-card-quickview [data-lusso-native-cart] form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const dialog = form.closest('.ls-card-quickview');
    const button = form.querySelector('button[type="submit"]');
    const choice = form.querySelector('input[name="variant-choice"]:checked');
    if (!button || !choice) return;
    const cart = document.querySelector('cart-drawer, cart-notification');
    const body = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(section => section.id));
      body.append('sections_url', window.location.pathname);
    }
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    button.querySelector('.loading__spinner')?.classList.remove('hidden');
    const addUrl = window.routes.cart_add_url.endsWith('.js') ? window.routes.cart_add_url : `${window.routes.cart_add_url}.js`;
    // Use XHR here rather than fetch: Optimaio monkey-patches window.fetch
    // and its post-add cart refresh can reject on iOS, leaving the user with
    // an animation but no reliable cart update.
    const addRequest = new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', addUrl, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = () => {
        try {
          const response = JSON.parse(xhr.responseText || '{}');
          if (xhr.status < 200 || xhr.status >= 300) throw new Error(response.description || response.message || 'Unable to add this product.');
          resolve(response);
        } catch (error) { reject(error); }
      };
      xhr.onerror = () => reject(new Error('Unable to connect to the cart.'));
      xhr.send(body);
    });
    addRequest
      .then(response => {
        if (response.status) throw new Error(response.description || response.message || 'Unable to add this product.');
        // The Ajax endpoint returns the added line item when no sections are
        // requested. Treat that 2xx response as the source of truth and show
        // success immediately; an optional section refresh can update the
        // drawer without making the add depend on a second network call.
        showAddConfirmation(dialog);
        if (cart && typeof cart.renderContents === 'function' && response.sections) cart.renderContents(response);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: body.get('id'),
            cartData: response
          });
        }
      })
      .catch(error => {
        const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
        const errorMessage = form.querySelector('.product-form__error-message');
        if (errorMessage) errorMessage.textContent = error.message;
        if (errorWrapper) errorWrapper.hidden = false;
      })
      .finally(() => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        button.querySelector('.loading__spinner')?.classList.add('hidden');
      });
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('.ls-card-sizes input[name="variant-choice"]')) return;
    const dialog = event.target.closest('.ls-card-quickview');
    const dialogScrollTop = dialog?.scrollTop || 0;
    const pageScrollY = window.scrollY;
    // Keep the hidden product id and submit state in sync synchronously. On
    // iOS, a tap can submit before a deferred change listener has completed.
    event.target.form.querySelector('input[name="id"]').value = event.target.value;
    const submitButton = event.target.form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
    }
    requestAnimationFrame(() => {
      if (dialog) dialog.scrollTop = dialogScrollTop;
      window.scrollTo({ top: pageScrollY, left: 0, behavior: 'instant' });
    });
  });
  document.addEventListener('click', event => {
    const addButton = event.target.closest('.ls-card-quickview product-form button[type="submit"]');
    // Do not show a success state optimistically. product-form.js publishes a
    // cartUpdate event only after Shopify confirms the add request; the
    // listener below handles the acknowledgement from that event.

    const thumb = event.target.closest('[data-quickview-index]');
    if (thumb) {
      event.preventDefault();
      const track = thumb.closest('[data-quickview-gallery]').querySelector('.ls-quickview-track');
      track.scrollTo({left:Number(thumb.dataset.quickviewIndex) * track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const arrow = event.target.closest('[data-quickview-step]');
    if (arrow) {
      event.preventDefault();
      event.stopPropagation();
      moveGallery(arrow.closest('[data-quickview-gallery]'), Number(arrow.dataset.quickviewStep));
      return;
    }
    const trigger = event.target.closest('[data-card-quickview]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.cardQuickview);
      if (!dialog) return;
      event.preventDefault();
      if (activeDialog?.open) activeDialog.close();
      previousOverflow = document.body.style.overflow;
      activeDialog = dialog;
      dialog.showModal();
      setupGallery(dialog);
      document.body.style.overflow = 'hidden';
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        activeDialog = null;
      }, { once: true });
      return;
    }
    if (event.target.closest('[data-close-quickview]')) activeDialog?.close();
    if (activeDialog && event.target === activeDialog) {
      const bounds = activeDialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) activeDialog.close();
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (!activeDialog || event.source !== 'product-form') return;
      const selected = activeDialog.querySelector('input[name="id"]')?.value;
      if (String(event.productVariantId) === selected) showAddConfirmation(activeDialog);
    });
  }

  // Some cart integrations stop the submit/click event before it reaches the
  // theme. Watching the cart bubble gives the quick view a reliable success
  // signal after the item has actually been added.
  const cartBubble = document.getElementById('cart-icon-bubble');
  if (cartBubble && window.MutationObserver) {
    let previousCartBubbleText = cartBubble.textContent;
    new MutationObserver(() => {
      const nextCartBubbleText = cartBubble.textContent;
      if (nextCartBubbleText !== previousCartBubbleText && activeDialog) showAddConfirmation(activeDialog);
      previousCartBubbleText = nextCartBubbleText;
    }).observe(cartBubble, { childList: true, subtree: true, characterData: true });
  }
})();
